import React, { useState } from 'react';
import { useEffect } from 'react';
import { useApiRequest } from '../../../utilities/api';
import { ERROR, SUCCESS } from '../../../utilities/api/actionTypes';
import EmployeeGrid from '../EmployeeGrid';
import IEmployee from '../models/IEmployee';

export interface IEmployeeLoaderProps {
    filter: string;
    employeeDepartment: string;
}

function useEmployees(filter, employeeDepartment): [string, IEmployee[]] {
    const [employeeApi, getEmployees] = useApiRequest(`${process.env.GATSBY_API_URL}/employees`);
    const [displayedEmployees, setDisplayedEmployees] = useState<IEmployee[]>([]);

    useEffect(() => {
        getEmployees();
    }, []);

    useEffect(() => {
        if (employeeApi.status === SUCCESS && Array.isArray(employeeApi.response)) {
            const employees = employeeApi.response;
            setDisplayedEmployees(employees.filter(employee => {
                if (filter && !employee.branches?.includes(filter)) {
                    return false;
                }
                if (employeeDepartment && employee.department !== employeeDepartment) {
                    return false;
                }
                return true;
            }));
        }
    }, [filter, employeeDepartment, employeeApi.status]);

    return [employeeApi.status, displayedEmployees];
}

export default function EmployeeLoader({ filter, employeeDepartment }: IEmployeeLoaderProps) {
    const [status, employees] = useEmployees(filter, employeeDepartment);
    return (
        <Response status={status}>
            <EmployeeGrid employees={employees} />
        </Response>
    );
}

function Response({ status, children }) {
    if (status === SUCCESS) {
        return children;
    } else if (status === ERROR) {
        return <h1 className="text-muted">Unable to load data.</h1>
    } else {
        return <span>Loading...</span>;
    }
}